// extracted by css-extract-rspack-plugin
export default {"cls1":"FileUpload-cls1_TPd","cls2":"FileUpload-cls2_CCs FileUpload-cls1_TPd"};